<template>
  <i
    :class="{
      [customClass]: true,
      [iconOpen]: !toggleWith,
      [iconClose]: toggleWith,
    }"
  ></i>
</template>

<script>
export default {
  props: {
    toggleWith: {
      required: true,
    },
    iconOpen: {
      type: String,
      default: 'fas fa-chevron-right',
    },
    iconClose: {
      type: String,
      default: 'fas fa-chevron-down',
    },
    customClass: {
      type: String,
    },
  },
};
</script>
